export default __webpack_public_path__ + "static/media/footer-bg.675cfb9a.webp";